<template>
  <div v-loading="loading" class="examining-app">
    <el-alert
      v-if="showAlert"
      :title="alertMsg"
      type="info"
      show-icon
    >
      <i slot="icon" class="el-icon-warning my-custom-icon" />
    </el-alert>
    <el-container class="examing-main">
      <el-main>
        <ExamItem
          :exam-detailed="examDetailed"
          :title="examDetailed.title"
          :topic="topic"
          :progress="progress"
          :tips-ids="tipsIds"
          :type-map="typeMap"
          :topic-video="topicVideo"
          :topic-statistics="topicStatistics"
          :outlines="outlines"
          :exams="exams"
          @nextupdate="onUpdate"
          @prevupdata="onPrevUpData"
          @checkTips="onCheckTips"
          @goStatistics="goStatistics"
          @showRule="showRule"
        />
      </el-main>
      <el-aside style="width: 336px;">
        <div class="count">
          <p v-if="$route.query.type" class="time">得分</p>
          <div v-if="$route.query.type" class="score">{{ userScore }}分</div>
          <p v-if="!$route.query.type &&examDetailed.answer_time" class="time"><img src="@/assets/img/coutDwo.png" class="coutDwo">剩余时间</p>
          <div v-if="!$route.query.type &&examDetailed.answer_time" class="dwon">
            <count-down v-if="timeShow" ref="countDown" :end-time="countdownEndTime" :end-text="endText" @countEnd="countEnd" />
          </div>
          <p v-if="!$route.query.type &&examDetailed.answer_time===0" class="time"><img src="@/assets/img/coutDwo.png" class="coutDwo">已用时间</p>
          <div v-if="!$route.query.type &&examDetailed.answer_time===0" class="dwon">
            <div class="timer">{{ timer }}</div>
          </div>
          <div v-if="!$route.query.type" class="progress-bar">
            <span>答题进度:{{ percentage }}%</span>
            <el-progress style="margin-top: 3px;" :show-text="false" :percentage="percentage" :color="customColor" />
          </div>
        </div>
        <div class="exam-item">
          <div v-if="$route.query.type" class="exam-item-title">
            <div class="right">
              <span />
              正确
            </div>
            <div class="wrong">
              <span />
              错误
            </div>
            <div class="active">
              <span />
              当前
            </div>
            <div class="tab" @click="lookWrong">
              {{ showWrong?'查看全部':'只看错题' }}
            </div>
          </div>

          <div v-else class="exam-item-title">
            <div class="done">
              <span />
              已做
            </div>
            <div class="not-done">
              <span />
              未做
            </div>
            <div class="active">
              <span />
              当前
            </div>
            <div class="tab">
              <img src="@/assets/img/tag.png" class="tag">
              标记
            </div>
          </div>
          <div class="exam-item-content" :style="{height:$route.query.type?'calc(100% - 40px)':'calc(100% - 110px)'}">
            <div v-for="(item, index) in progressList" :key="index" class="single">
              <div class="item-content-tips">
                <span />
                {{ item.name }}
              </div>
              <div v-if="$route.query.type" class="single-content">
                <div
                  v-for="(item1, index2) in item.list"
                  v-show="showWrong?item1.is_right==0:(item1.is_right==0||item1.is_right==1||!item1.is_right)"
                  :key="index2"
                  :class="{ 'content-item': true,'right2':item1.is_right==1,'wrong2':item1.is_right==0||!item1.is_right, 'yellow': topic.id == item1.id}"
                  @click="topicChange(item1,index2)"
                >
                  <img v-if="item1.remarks" src="@/assets/img/tag.png" class="tag_img">
                  {{ exams.map(obj => obj.id).indexOf(item1.id)+1 }}
                </div>
              </div>
              <div v-else class="single-content">
                <div
                  v-for="(item1, index2) in item.list"
                  :key="index2"
                  :class="{'nowTopic':((examDetailed.answer_mode==2&&examDetailed.answer_rule==2)||(examDetailed.answer_mode==3&&examDetailed.answer_rule==2))&&nowTopic.id==item1.id&&topic.id!=item1.id, 'content-item': true, 'blue': (item1.value.length>1&&(item1.type==2||item1.type==18)||(item1.type!=2&&item1.type!=18&&item1.value.length)), 'white': !item1.value.length && (topic.id != item1.id), 'yellow': topic.id == item1.id ,'dis_color':(examDetailed.answer_mode==2&&examDetailed.answer_rule==1&&item1.value&&item1.nextCheck)||(examDetailed.answer_mode==3&&examDetailed.answer_rule==1&&item1.nextCheck)}"
                  @click="topicChange(item1,index2)"
                >
                  <img v-if="item1.remarks" src="@/assets/img/tag.png" class="tag_img">
                  <span v-if="((examDetailed.answer_mode==2&&examDetailed.answer_rule==2)||(examDetailed.answer_mode==3&&examDetailed.answer_rule==2))&&nowTopic.id==item1.id&&topic.id!=item1.id">答题中</span>
                  <span v-else>{{ exams.map(obj => obj.id).indexOf(item1.id)+1 }}</span>
                </div>
              </div>
            </div>
          </div>
          <el-button v-if="!$route.query.type" type="primary" style="width: 100%;" class="paper_btn" @click="submit">交卷</el-button>

        </div>
        <!-- 提示消息 -->
        <Tips
          ref="tipParmas"
          :tip-parmas="tipParmas"
          @confirm="tipsConfirm"
          @cancel="tipsClose"
        />
        <!-- 提示消息 -->
        <Tips
          :tip-parmas="tipParmas2"
          @confirm="tipsConfirm"
          @cancel="tipsClose"
        />
        <!-- 警告 -->
        <Warn
          :warn-visible="warnVisible"
          :num="leaveNum"
          :message="warnMessage"
          @cancel="warnCancel"
          @confirm="submit"
        />
        <!-- 成绩统计 -->
        <examStatistics :exam-detailed="examDetailed" :statistics-type="statisticsType" :statistics-visible="statisticsVisible" :test-info="testInfo" @update:statisticsVisible="statisticsChange" />
        <!-- 考试模式提示 -->
        <examTypeTips :tip-parmas="tipTypeParmas" @know="know" />
        <!-- 首次点击题组题提示 -->
        <examTypeTips2 :tip-parmas="tipTypeParmas2" @know="know" />
        <!-- 逐题模式提示文案 -->
        <Tips2
          :tip-parmas="tipParmas3"
          @confirm="tipsConfirm2"
          @cancel="tipsClose2"
        />
      </el-aside>
    </el-container>
  </div>

</template>

<script>
import {  getExamDetail, getExamDetailed, getQuestionAdditional, getUserAnswer, getUserFirstAnswerScore, getAnswerList, severTime, saveCheat, answerSubmit,saveCheatBatch } from '@/http/index'
import { dateMinutes2, dateMinutes, nowTime, dateToString2, parseExamDate, getExamTimestamp } from '@/utils/index'
import axios from 'axios'
import ExamItem from "@/components/examTempalte/ExamItem.vue"
import countDown from '@/components/countdown/index2'
import examStatistics from '../examList/child/statistics.vue'
import Tips from '../examList/child/tips.vue'
import Tips2 from '../examList/child/tips2.vue'
import Warn from './child/warn.vue'
import { handleAnswer, handleScore, fullScreen, turnFullScreen, isFullscreenActive } from '@/utils/exam'
import { connectWebsocket, closeWebsocket } from '../../utils/ws.js'
import examTypeTips from '../examList/child/typeTips.vue'
import examTypeTips2 from '../examList/child/typeTips2.vue'
import {getCurrentLocation} from '@/utils/location'

export default {
  beforeRouteEnter(to, from, next) {
		if (from.path === '/') {
      next(vm => {
				vm.$router.replace('/home/examinationList')
			})
			return
		} else {
			next();
		}
	},
  components: {
    ExamItem,
    countDown,
    examStatistics,
    Tips,
    Tips2,
    Warn,
    examTypeTips,
    examTypeTips2
  },
  data() {
    return {
      offlineStartTime: null,  // 断网开始时间戳
      heartbeatTimer: null,    // 心跳定时器
      endTime: '',
      tipParmas: {
        tipsVisible: false,
        tipsContent: '',
        disabled: false
      },
      tipParmas2: {
        tipsVisible: false,
        tipsContent: ''
      },
      tipParmas3: {
        tipsVisible: false,
        tipsContent: ''
      },
      warnVisible: false,
      warnMessage: '',
      examDetailed: {},
      isFullscreen: false,
      examList: [],
      customColor: [
        { color: '#5FCA71' }
      ],
      exams: [],
      progress: {
        total: 0,
        current: 1
      },
      typeMap: [{
        id: 1,
        name: '单选题'
      }, {
        id: 2,
        name: '多选题'
      }, {
        id: 8,
        name: '案例分析'
      }, {
        id: 11,
        name: 'A1型题'
      }, {
        id: 12,
        name: 'A2型题'
      }, {
        id: 15,
        name: 'A3/A4型题'
      }, {
        id: 16,
        name: 'B型题'
      }, {
        id: 17,
        name: 'C型题'
      }, {
        id: 18,
        name: 'X题型'
      }, {
        id: 19,
        name: '不定项选择题'
      }, {
        id: 22,
        name: '判断题'
      }
      ],
      statisticsVisible: false,
      warnEnd: false,
      testInfo: {},
      tipsIds: [],
      leaveNum: 0,
      numTotal: null,
      timeout: null,
      switchCheat: 0,
      longSwitchDetection: 0,
      longSwitchTotalMinute: 0,
      longSwitchSingleMinute: 0,
      switchStorageKey: '',
      switchRecords: [],
      switchTotalSeconds: 0,
      switchStartTime: null,
      isPageHidden: false,
      time: null,
      date_start: '',
      date_end: '',
      exam_time: '',
      answer_time: 0,
      btnShow: true,
      showFull: true,
      leaveTime: '',
      showTips: true,
      examType: 'start',
      setInfoStatus: false,
      endText: '考试结束',
      topicVideo: [],
      topicStatistics: {},
      statisticsType: '0',
      anwserList: [],
      timer: '00:00:00',
      second: 0,
      minute: 0,
      hour: 0,
      flag: null,
      showWrong: false,
      loading: true,
      userScore: 0,
      pageType: 1,
      finsihVisible: false,
      addressInfo: {
        lat: 0,
        lng: 0,
        address: '未知',
      },
      outlines: '',
      network: true,
      showAlert: false,
      alertMsg: '',
      examNum: -1,
      tipTypeParmas: {
        tipsVisible: false,
        title: '',
        tipsContent: ''
      },
      tipTypeParmas2: {
        tipsVisible: false,
        tipsContent: ''
      },
      nowTopic: {},
      nowType: '',
      nextType: '',
      firstTypeShow: true,
      timeShow: false,
      stayTime: 0,
      intervalId: null,
      checkId: null,
      intervalCount: 0,
      isSafari: false,
      submit_type: 0,
      userId: '',
      oldExamList: [],
      onceSubmitArr: [],
      noWorkChearArr: [],
    }
  },
  computed: {
    gwtExamContDwo: {
      get() {
        return this.endTime
      },
      set(val) {
        return val
      }
    },
    progressList() {
      const groupExams = this.exams.reduce((r, c) => {
        if (!r[c.type]) {
          r[c.type] = []
        }
        r[c.type].push(c)
        return r
      }, [])
      const sortedExams = this.topicsSeq().map(v => groupExams[v]).filter(v => v && v.length !== 0).map(it => ({ name: this.typeMap.find(i => i.id === it[0].type).name, list: it }))
      return sortedExams
    },
    topicIndex() {
      return Math.min(Math.max(this.progress.current - 1, 0), this.exams.length - 1)
    },
    topic() {
      const topic = this.exams[this.topicIndex] || {}
      return topic
    },
    countdownEndTime() {
      const timestamp = getExamTimestamp(this.gwtExamContDwo)
      return Number.isFinite(timestamp) ? String(Math.floor(timestamp / 1000)) : ''
    },
    percentage() {
      if (this.setInfoStatus && !this.$route.query.type) {
        localStorage.setItem('testInfo', JSON.stringify(this.exams))
      }
      return Number(((this.exams.filter(item => item.value.length !== 0).length / this.exams.length) * 100).toFixed(2))
    }
  },
  watch: {
    'exams': {
      handler(val, oldVal) {
        if (oldVal) {
          // this.oldExamList = [...val]
          const compareByIdAndValueArr = this.compareByIdAndValue(val, this.oldExamList)
          if (compareByIdAndValueArr && compareByIdAndValueArr.length > 0) {
            this.onceSubmitArr = this.onceSubmitArr.concat(compareByIdAndValueArr)
            localStorage.setItem('unsentAnswers', JSON.stringify(this.onceSubmitArr))
            this.onceSubmit(0, 0);
            this.$nextTick(() => {
              this.oldExamList = JSON.parse(JSON.stringify(val))
            })
          }
        }
      },
      deep: true,
      immediate: true
    },
    // 'nowTopic': {
    //   handler(val, oldVal) {
    //     // if (val) {
    //     // console.log(val, 'nowTopic改变啦')
    //     // if (this.hasData(val.value)) {
    //     //   this.onceSubmitArr.push(val)
    //     //   this.onceSubmit(0, 0);
    //     // }
    //     // }
    //   },
    //   // deep: true,
    //   // immediate: true
    // },
    'network': {
      handler(val, oldVal) {
        if (val) {
          this.showAlert = false;
          if (this.warnEnd) {
            this.warnVisible = false;
            this.getNoWorkEnd()
            return
          }
          if (this.noWorkChearArr.length > 0) {
            this.flushCheatQueue()
          }
          // if (!oldVal) { // 联网判断有十个答案了自动交一次答案
          //   const num = this.exams.filter(item => {
          //     if (Array.isArray(item.value)) {
          //       return item.value.length > 0;
          //     } else {
          //       return item.value !== '';
          //     }
          //   }).length;
          //   if (num >= 10) {
          //     this.submitAnswer();
          //   }
          // }
        } else {
          this.alertMsg = '请注意！当前网络环境较差，可能会导致交卷失败并没有成绩，请调整网络后继续考试！'
          this.showAlert = true;
        }
      }
    }
  },
  async created() {
    if(this.$store.state.examDetailed.location_permission_web == 1){
      this.addressInfo = await getCurrentLocation()
    }
    if (this.$route.query.type) {
      this.pageType = 2;
      // this.getExamInfo();
      this.examDetailed = this.$store.state.examDetailed;
      this.getScore();
    } else {
      this.isSafari = localStorage.getItem('isSafari') === 'true'
      this.examDetailed = this.$store.state.examDetailed;
      this.userId = this.$store.state.userInfo.user_id;
      this.answer_time = this.examDetailed.answer_time;
      if (this.examDetailed.reset_answer.is_reset) {
        this.anwserList = this.examDetailed.reset_answer.answer
      }
      if (this.examDetailed.answer_mode != 1) {
        this.tipTypeParmas = {
          showTime: true,
          tipsVisible: true,
          title: `${this.examDetailed.answer_mode == 2 ? '逐题模式' : '逐题型模式'}（${this.examDetailed.answer_rule == 1 ? '禁止回看' : '禁止回做'}）已开启`,
          tipsContent: this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目禁止再次点击查看</p>'
            : this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 2 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目仅支持查看，禁止再次答题</p>'
              : this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型禁止再次点击查看</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>'
                : '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型仅支持查看，禁止再次答题</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>'
        }
      }
      this.getExamList()
      // this.getIPAddress();
    }
  },
  beforeDestroy() {
    this.stopHeartbeat();
    if (this.pageType === 1) {
      this.tipParmas.tipsVisible = false;
      this.tipParmas2.tipsVisible = false;
      this.warnVisible = false;
      turnFullScreen();
      // closeWebsocket();
      clearInterval(this.flag)
      clearInterval(this.intervalId)
      this.showFull = false;
      window.onblur = function() {
      };
      window.onfocus = function() {
      };
      this.timeShow = false;
      window.removeEventListener('fullscreenchange', this.handleFullscreenChange)
      window.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
      window.removeEventListener('visibilitychange', this.pageHidden)
      window.removeEventListener('offline')
      window.removeEventListener('online')
      document.body.oncontextmenu = document.body.ondragstart = document.body.onselectstart = document.body.onbeforecopy = function() { return true; };
      window.onkeyup = window.onkeydown = window.onKeyPress = document.onkeyup = document.onkeydown = document.onKeyPress = document.body.onkeyup = document.body.onkeydown = document.body.onKeyPress  = function() { // 防止学生使用快捷键组合
        return true
      };
      this.$messageBox.close()
    }
  },
  mounted() {
    var that = this;
    if (this.$route.query.type) {
      return
    }
    this.$nextTick(() => {
      const isFullscreen = isFullscreenActive();
      if (!isFullscreen && !this.$route.query.type) {
        this.$messageBox.alert('考试期间不允许退出全屏', '警告', {
          confirmButtonText: '确定',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          callback: action => {
            fullScreen();
          }
        });
      }
    });
    window.addEventListener('offline', () => {
      this.network = false
      this.offlineStartTime = Date.now() 
    })
    window.addEventListener('online', () => {
      this.network = true
      if (this.offlineStartTime) {
        const duration = Math.round((Date.now() - this.offlineStartTime) / 1000)
        const examDisconnectInternet = localStorage.getItem('examDisconnectInternet') || 5
        if (duration > Number(examDisconnectInternet)){
          this.saveCheatNum(duration, 2, 8)
        }
        this.offlineStartTime = null
      }
    })
    // if (this.$store.state.examDetailed.cheat === 1) {
    const switchTimes = this.$store.state.examDetailed.switch_times
    this.numTotal = Number(switchTimes || 0)
    this.timeout = Number(this.$store.state.examDetailed.timeout || 0)
    this.switchCheat = Number(this.$store.state.examDetailed.switch_cheat || 0)
    this.longSwitchDetection = Number(this.$store.state.examDetailed.long_switch_detection || 0)
    this.longSwitchTotalMinute = Number(this.$store.state.examDetailed.long_switch_total_minute || 0)
    this.longSwitchSingleMinute = Number(this.$store.state.examDetailed.long_switch_single_minute || 0)
    this.switchStorageKey = `examSwitchInfo_${this.$store.state.examDetailed.id || this.$route.query.id}`
    this.initSwitchInfo()
    window.onblur = function() {
      that.pageHide();
    };
    window.onfocus = function() {
      that.pageShow();
    };
    window.addEventListener("visibilitychange", this.pageHidden);
    document.body.oncontextmenu = document.body.ondragstart = document.body.onselectstart = document.body.onbeforecopy = function() { return false; };
    window.onkeyup = window.onkeydown = window.onKeyPress = document.onkeyup = document.onkeydown = document.onKeyPress = document.body.onkeyup = document.body.onkeydown = document.body.onKeyPress  = function() { // 防止学生使用快捷键组合
      return false
    };
    // }
    window.addEventListener("fullscreenchange", this.handleFullscreenChange);
    window.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    this.startHeartbeat();
  },

  methods: {
    compareByIdAndValue(arr1, arr2) {
      const arr2Map = new Map(arr2.map(item => [item.id, item]));

      return arr1.filter(item1 => {
        const item2 = arr2Map.get(item1.id);
        if (!item2) return true;
        return !this.isValueEqual(item1.value, item2.value);
      });
    },
    isValueEqual(value1, value2) {
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) return false;
        return value1.every((item, index) => item === value2[index]);
      }
      return value1 === value2;
    },
    uniqueById(arr) {
      const map = new Map();
      arr.forEach(item => {
        if (!map.has(item.question_id)) {
          map.set(item.question_id, item);
        }
      });
      return Array.from(map.values());
    },
    initExamSession() {
      if (this.examDetailed.reset_answer.is_reset) {
        this.nowTopic = this.examDetailed.reset_answer.last_answer ? this.exams.find(item => item.id == this.examDetailed.reset_answer.last_answer) : JSON.parse(JSON.stringify(this.exams[0]))
        this.progress.current = this.examDetailed.reset_answer.last_answer ? this.exams.map(item => item.id).indexOf(Number(this.examDetailed.reset_answer.last_answer)) + 1 : 1
        if (this.examDetailed.answer_mode == 3) {
          this.nowType = this.nowTopic.type;
          this.nextType = this.getNextQuesType(this.nowType)
        }
      } else {
        this.isModifyTime('start')
        this.nowTopic = JSON.parse(JSON.stringify(this.exams[0]))
        if (this.examDetailed.answer_mode == 3) {
          this.nowType = this.exams[0].type;
          this.nextType = this.getNextQuesType(this.nowType)
        }
      }
      localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
      localStorage.setItem('examId', this.examDetailed.id)
      localStorage.setItem('userId', this.userId)
      this.setInfoStatus = true;
      if (this.examDetailed.answer_mode == 1) {
        this.getTime()
      }
    },
    getNewTime(time, s) {
      const startDate = parseExamDate(time);
      const endDate = new Date(startDate.getTime() - s * 1000);
      const year = endDate.getFullYear();
      const month = String(endDate.getMonth() + 1).padStart(2, '0');
      const day = String(endDate.getDate()).padStart(2, '0');
      const hours = String(endDate.getHours()).padStart(2, '0');
      const minutes = String(endDate.getMinutes()).padStart(2, '0');
      const seconds = String(endDate.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 显示网络环境差的提示
    showNetworkAlert(){
      this.alertMsg = '请注意，当前网络环境较差，可能会导致交卷失败没有成绩，请调整网络后继续考试！'
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    },
    onceSubmit(submit_type, complete) {
      const answerArr = JSON.parse(JSON.stringify(this.onceSubmitArr))
      const answer = this.uniqueById(handleAnswer(answerArr));
      const answer2 = handleAnswer();
      const total = handleScore();
      console.log(answer, 'answer------')
      this.$store.dispatch('onceSubmit', {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.examDetailed.id,
        answer: JSON.stringify(answer),
        answer_num: answer2.filter(item => item.answer).length,
        right: answer2.filter(item => item.is_right === 1).length,
        score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
        submit_type: submit_type,
        complete: complete,
        address: this.addressInfo.address,
        lat:this.addressInfo.lat,
        lng:this.addressInfo.lng,
        // last_answer: this.nowTopic.id ? this.nowTopic.id : '',
        last_answer: this.onceSubmitArr[0].id || '',
        reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
        id: localStorage.getItem('examAnswerId'),
        exam_date_start: this.examDetailed.reset_answer.is_reset ? this.getNewTime(localStorage.getItem('examSeverTime'), Number(this.examDetailed.reset_answer.exam_time)) : localStorage.getItem('examSeverTime')
      }).then(res => {
        if (res.code == 200) {
          if (res.data.answer_time != this.answer_time) {
            this.answer_time = res.data.answer_time
            const time = this.getExamTime(this.date_start, res.data.ent_time, res.data.answer_time)
            this.endTime = dateToString2(this.date_start, time)
          }
          this.onceSubmitArr = this.removeDuplicatesById(this.onceSubmitArr, answerArr)
          localStorage.setItem('unsentAnswers', JSON.stringify(this.onceSubmitArr))
          console.log(this.onceSubmitArr, 'this.onceSubmitArr----')
        } else {
          if (res.message == "您已被管理员强制交卷，有问题请联系管理员") {
            this.submit_type = 6
            this.forceConfirm('', res.data.sever_time);
          }
          if (res.message === "本场考试已取消" || res.message === '您已被移出本场考试') {
            localStorage.removeItem('examId')
            localStorage.removeItem('testInfo')
            localStorage.removeItem('unsentAnswers')
            localStorage.removeItem('examTimeStart')
            localStorage.removeItem('testPaper')
            localStorage.removeItem('nowTopic')
            localStorage.removeItem('stayTime')
            clearInterval(this.intervalId)
            this.$router.go(-2);
          }
        }
      }).catch(err => {
        if (err == 'timeout') {
          this.network = false
          this.offlineStartTime = Date.now()
          return
        }
        if (err.message === "本场考试已取消" || err.message === '您已被移出本场考试') {
          localStorage.removeItem('examId')
          localStorage.removeItem('testInfo')
            localStorage.removeItem('unsentAnswers')
          localStorage.removeItem('examTimeStart')
          localStorage.removeItem('testPaper')
          localStorage.removeItem('nowTopic')
          localStorage.removeItem('stayTime')
          this.clearSwitchInfo()
          clearInterval(this.intervalId)
          this.$router.go(-2);
        }
      })
    },
    removeDuplicatesById(arr1, arr2) {
      const idsToRemove = arr2.map(item => item.id);
      return arr1.reduce((acc, current) => {
        if (!idsToRemove.includes(current.id)) {
          acc.push(current);
        }
        return acc;
      }, []);
    },
    showRule() {
      this.tipTypeParmas = {
        showTime: false,
        tipsVisible: true,
        title: `${this.examDetailed.answer_mode == 2 ? '逐题模式' : '逐题型模式'}（${this.examDetailed.answer_rule == 1 ? '禁止回看' : '禁止回做'}）已开启`,
        tipsContent: this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目禁止再次点击查看</p>'
          : this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 2 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目仅支持查看，禁止再次答题</p>'
            : this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型禁止再次点击查看</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>'
              : '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型仅支持查看，禁止再次答题</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>',
        special:true
      }
    },
    getNextQuesType(currentType) {
      for (let i = 0; i < this.exams.length; i++) {
        if (this.exams[i].type == currentType) {
          for (let j = i + 1; j < this.exams.length; j++) {
            if (this.exams[j].type != currentType) {
              return this.exams[j].type;
            }
          }
          return currentType;
        }
      }
      return undefined;
    },
    findLastObjectWithNonEmptyValue(array) {
      let lastIndexWithNextCheck = -1;
      for (let i = array.length - 1; i >= 0; i--) {
        if (array[i].nextCheck) {
          lastIndexWithNextCheck = i;
          break;
        }
      }

      if (lastIndexWithNextCheck !== -1 && lastIndexWithNextCheck < array.length - 1) {
        return array[lastIndexWithNextCheck + 1];
      }

      return array[array.length - 1];
    },
    know(data) {
      if (data == 1) {
        this.tipTypeParmas.tipsVisible = false;
        if (this.exams.every(item => item.type == 8 || item.type == 15) && this.firstTypeShow) {
          let content = ''
          if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 1) {
            content = '<p>1.本场考试题组题子题必须按照题号顺序作答</p><p>2.只有做完当前子题才能切换下一个子题作答</p><p>3.已做完的子题禁止回退查看</p>'
          }
          if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
            content = '<p>本场考试题组题题型内已做完的子题禁止回退查看</p>'
          }
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 1) {
            content = '<p>1.本场考试题组题子题必须按照题号顺序作答</p><p>2.只有做完当前子题才能切换下一个子题作答</p><p>3.已做完的子题仅支持查看，禁止再次答题</p>'
          }
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
            content = '<p>本场考试题组题题型内已做完的子题仅支持查看，禁止再次答题</p>'
          }
          if (content) {
            this.tipTypeParmas2 = {
              tipsVisible: true,
              tipsContent: content
            }
            this.getTime();
            return
          }
        }
        // this.timeShow=true;
        this.getTime();
      } else if(data == 3){
        this.tipTypeParmas.tipsVisible = false;
      } else {
        this.tipTypeParmas2.tipsVisible = false;
        this.firstTypeShow = false;
      }
    },
    submitAnswer() {
      severTime().then(res => {
        // this.exam_time = dateMinutes2(res.data.sever_time, localStorage.getItem('examTimeStart'))
        const answer = handleAnswer();
        const total = handleScore();
        getExamDetail({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          exam_id: this.examDetailed.id
        }).then(res3 => {
          if (res3.code == 200) {
            if (res3.data.answer_time != this.answer_time) {
              const time1 = this.answer_time
              this.answer_time = res3.data.answer_time
              const time = this.getExamTime(this.date_start, res3.data.ent_time, res3.data.answer_time)
              this.endTime = dateToString2(this.date_start, time)
              const number = 	Number(this.answer_time) - Number(time1)
              this.examType = 'addTime'
              if (number) {
                this.tipParmas2 = {
                  tipsContent: `<div>本场考试结束时间延长${number}分钟，请注意作答时间</div>`,
                  tipsVisible: true,
                  confirmText: '确认'
                }
              }
            }
            this.onceSubmit(0, 0)
            // const parmas = {
            //   token: localStorage.getItem('token'),
            //   secret: localStorage.getItem('secret'),
            //   hospital_id: localStorage.getItem('hospital_id'),
            //   exam_id: this.examDetailed.id,
            //   answer: JSON.stringify(answer),
            //   answer_num: answer.filter(item => item.answer).length,
            //   date_start: this.examDetailed.reset_answer.is_reset ? this.examDetailed.reset_answer.date_start : localStorage.getItem('examTimeStart'),
            //   date_end: res.data.sever_time,
            //   right: answer.filter(item => item.is_right === 1).length,
            //   score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
            //   exam_time: this.examDetailed.reset_answer.is_reset ? Number(this.stayTime) + Number(this.examDetailed.reset_answer.exam_time) : Number(this.stayTime),
            //   // exam_time: this.examDetailed.reset_answer.is_reset ? Number(this.exam_time) + Number(this.examDetailed.reset_answer.exam_time) : this.exam_time,
            //   submit_type: 0,
            //   reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
            //   address: this.address,
            //   complete: 0,
            //   last_answer: this.nowTopic.id ? this.nowTopic.id : ''
            // }
            // this.$store.dispatch('submit', parmas).then(res2 => {
            //   this.examNum = 0
            // }).catch(err => {
            //   this.examNum - 1
            //   if (err == 'timeout') { // 弱网处理
            //     this.alertMsg = '请注意，当前网络环境较差，可能会导致交卷失败没有成绩，请调整网络后继续考试！'
            //     this.showAlert = true;
            //     setTimeout(() => {
            //       this.showAlert = false;
            //     }, 3000);
            //     return
            //   }
            //   if (err.message === "本场考试已取消" || err.message === '您已被移出本场考试') {
            //     localStorage.removeItem('examId')
            //     localStorage.removeItem('testInfo')
            //     localStorage.removeItem('examTimeStart')
            //     localStorage.removeItem('testPaper')
            //     localStorage.removeItem('nowTopic')
            //     localStorage.removeItem('stayTime')
            //     clearInterval(this.intervalId)
            //     this.$router.go(-2);
            //   }
            // })
          } else {
            if (res3.message == "您已被管理员强制交卷，有问题请联系管理员") {
              this.submit_type = 6
              this.forceConfirm('', res.data.sever_time);
            }
            if (res3.message === "本场考试已取消" || res3.message === '您已被移出本场考试') {
              localStorage.removeItem('examId')
              localStorage.removeItem('testInfo')
              localStorage.removeItem('unsentAnswers')
              localStorage.removeItem('examTimeStart')
              localStorage.removeItem('testPaper')
              localStorage.removeItem('nowTopic')
              localStorage.removeItem('stayTime')
              clearInterval(this.intervalId)
              this.$router.go(-2);
            }
          }
        })
      }).catch(err => {
        if (err == 'timeout') {
          this.alertMsg = '请注意，当前网络环境较差，可能会导致交卷失败没有成绩，请调整网络后继续考试！'
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);
        }
      })
    },
    forceConfirm(type, time) {
      this.exam_time = type == 2 ? dateMinutes2(this.endTime, this.date_start) : Number(this.stayTime)
      const answerArr = JSON.parse(JSON.stringify(this.onceSubmitArr))
      const answer =  this.uniqueById(handleAnswer(answerArr));
      const answer2 = handleAnswer();
      const total = handleScore();
      const parmas = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        // app_id: this.examDetailed.app_id,
        exam_id: this.examDetailed.id,
        answer: JSON.stringify(answer),
        answer_num: answer2.filter(item => item.answer).length,
        // date_start: this.examDetailed.reset_answer.is_reset ? this.examDetailed.reset_answer.date_start : localStorage.getItem('examTimeStart'),
        // date_end: time,
        right: answer2.filter(item => item.is_right === 1).length,
        score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
        // exam_time: this.examDetailed.reset_answer.is_reset ? Number(this.exam_time) + Number(this.examDetailed.reset_answer.exam_time) : this.exam_time,
        submit_type: this.submit_type,
        reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
        address: this.addressInfo.address,
        lat:this.addressInfo.lat,
        lng:this.addressInfo.lng,
        complete: 1,
        last_answer: this.nowTopic.id ? this.nowTopic.id : '',
        id: localStorage.getItem('examAnswerId'),
        exam_date_start: this.examDetailed.reset_answer.is_reset ? this.getNewTime(localStorage.getItem('examSeverTime'), Number(this.examDetailed.reset_answer.exam_time)) : localStorage.getItem('examSeverTime')
      }
      this.$store.dispatch('onceSubmit', parmas).then(async res2 => {
        this.tipParmas.disabled = false
        if (res2.code === 200) {
          this.$message.success("提交成功");
          await this.isModifyTime('end')
          localStorage.removeItem('examId')
          localStorage.removeItem('testInfo')
          localStorage.removeItem('unsentAnswers')
          localStorage.removeItem('examTimeStart')
          localStorage.removeItem('testPaper')
          localStorage.removeItem('nowTopic')
          localStorage.removeItem('stayTime')
          this.clearSwitchInfo()
          clearInterval(this.intervalId)
          this.examType = 'end'
          if (this.examDetailed.answer_time === 0) {
            clearInterval(this.flag)
            this.timer = '考试结束'
          } else {
            this.$refs.countDown?.endCount();
          }
          this.testInfo = {
            avatar: this.$store.state.userInfo.avatar,
            realname: this.$store.state.userInfo.realname,
            score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
            time: this.examDetailed.reset_answer.is_reset ? Number(this.exam_time) + Number(this.examDetailed.reset_answer.exam_time) : Number(this.exam_time),
            pass: total >= this.examDetailed.pass_score ? '及格' : '不及格',
            exam_id: this.examDetailed.id,
            exam_name: this.examDetailed.title,
            rate: ((total / this.examDetailed.score) * 100).toFixed(1),
            review_option: this.examDetailed.review_option ? this.examDetailed.review_option.split(',') : ''
          }
          closeWebsocket();
          this.$refs.tipParmas.btnChange(false)
          if (type == 1) {
            this.tipParmas = {
              tipsContent: `<div>检测到您在未交卷的情况下关闭浏览器窗口，为防止作弊已自动提交考试答案！</div>`,
              tipsVisible: true,
              confirmText: '确认',
              showClose: true,
              disabled: false
            }
            return
          } else {
            this.statisticsType = '0';
            this.statisticsVisible = true;
            this.tipParmas.tipsVisible = false;
          }
        }
      })
    },
    // getIPAddress() {
    //   const url = "https://restapi.amap.com/v3/ip?parameters"
    //   const params = {
    //     key: "5a00269f074572c2d96d2779da41ae44"
    //   }
    //   axios({
    //     method: "get",
    //     url,
    //     params
    //   }).then(res => {
    //     this.address = res.data.city;
    //   })
    // },
    lookWrong() {
      this.showWrong = !this.showWrong;
    },
    async getExamInfo() {
      const { data } = await getExamDetail({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.$route.query.id
      })
      this.examDetailed = data;
      this.getScore();
    },
    async getScore() {
      const res = await getUserFirstAnswerScore({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.$route.query.id
      })
      if (res.code === 200) {
        if (res.data.answer) {
          this.anwserList = JSON.parse(res.data.answer)
        }
        this.userScore = res.data.score ? res.data.score : 0
        this.getExamList();
      }
    },
    getWs() {
      connectWebsocket(
        // 测试地址
        `ws://ykb-exam-test.yikaobang.com.cn/ws?exam_id=${this.$route.query.id}&user_id=${this.$store.state.userInfo.user_id}`,
        // 正式地址
        // `wss://ykb-exam.yikaobang.com.cn/ws?exam_id=${this.$route.query.id}&user_id=${this.$store.state.userInfo.user_id}`,
        // 传递给后台的数据
        { openexe: 'openexe' },
        // 成功拿到后台返回的数据的回调函数
        (data) => {
          const res = JSON.parse(data);
          if (res.title === "考试延长通知") {
            const time1 = this.endTime
            const time = this.getExamTime(this.date_start, res.ext.ent_time, res.ext.exam_time)
            this.endTime = dateToString2(this.date_start, time)
            this.gwtExamContDwo =  this.endTime;
            const number = Math.floor(((getExamTimestamp(this.endTime) - getExamTimestamp(time1)) / (1000 * 60)) % 60)
            this.examType = 'addTime'
            if (number) {
              this.tipParmas2 = {
                tipsContent: `<div>本场考试结束时间延长${number}分钟，请注意作答时间</div>`,
                tipsVisible: true,
                confirmText: '确认'
              }
            }
          } else if (res.title === "考试取消通知" || res.title === "考试移除通知") {
            this.examType = 'remove'
            this.tipParmas2 = {
              tipsContent: res.title === "考试取消通知" ? `<div>本场考试已取消，答题情况将不会记录和统计成绩</div>` : `<div>您已被移除本场考试，答题情况将不会记录和统计成绩</div>`,
              tipsVisible: true,
              confirmText: '确认'
            }
          }
        },
        // websocket连接失败的回调函数
        (err) => {
          // console.log('失败的回调函数', err)
        }
      )
    },
    startTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.stayTime++;
        // console.log(this.stayTime,'this.stayTime-------')
        localStorage.setItem('stayTime', this.stayTime)
        // this.intervalCount++;
        // console.log(this.intervalCount,'this.intervalCount-------')
        // if (this.intervalCount >= 10) { // 每10秒增加一次stayTime
        //   this.stayTime += 10;
        //   this.intervalCount = 0; // 重置计数
        //   localStorage.setItem('stayTime',this.stayTime)
        // }
      }, 1000);
    },
    pageHide() {
      if (this.warnEnd || this.isPageHidden) return
      this.isPageHidden = true
      this.switchStartTime = Date.now()
      const switchStartTime = this.switchStartTime
      this.showTips = false;
      this.leaveTime = ''
      clearInterval(this.intervalId)
      if (this.network) {
        severTime().then(res => {
          if (this.isPageHidden && this.switchStartTime === switchStartTime) {
            this.leaveTime = res.data.sever_time
          }
        }).catch(err => {
          if (this.isPageHidden && this.switchStartTime === switchStartTime) {
            this.leaveTime = nowTime(switchStartTime)
          }
        })
      } else {
        this.leaveTime = nowTime(switchStartTime)
      }
    },
    pageShow() {
      if (this.warnEnd || !this.isPageHidden) return
      const switchStartTime = this.switchStartTime || Date.now()
      const leaveTime = this.leaveTime
      this.isPageHidden = false
      this.switchStartTime = null
      const handleShow = endTime => {
        let time = Math.max(0, Math.round((Date.now() - switchStartTime) / 1000))
        if (leaveTime && endTime) {
          time = dateMinutes2(endTime, leaveTime)
        }
        setTimeout(() => {
          if (this.examType === 'end' || this.examType === 'remove') return
          this.stayTime = this.stayTime + time
          this.startTimer();
          const switchDuration = Math.max(0, Number(time) || 0)
          const nextTotalSeconds = this.switchTotalSeconds + switchDuration
          const isTimeoutCheat = this.switchCheat === 1 && switchDuration > this.timeout
          const isTotalDurationCheat = this.switchCheat === 1 && this.longSwitchDetection === 1 && nextTotalSeconds > this.longSwitchTotalMinute * 60
          const isSingleDurationCheat = this.switchCheat === 1 && this.longSwitchDetection === 1 && switchDuration > this.longSwitchSingleMinute * 60
          const isCheatSwitch = isTimeoutCheat || isTotalDurationCheat || isSingleDurationCheat
          this.saveSwitchInfo(switchDuration, isCheatSwitch, leaveTime || nowTime(switchStartTime))
          this.saveCheatNum(switchDuration, isCheatSwitch ? 1 : 2)
          const switchLimitType = this.getSwitchLimitType(switchDuration)
          if (switchLimitType) {
            this.showSwitchSubmitWarning(switchLimitType)
          } else if (isCheatSwitch) {
            this.tipParmas.tipsVisible = false;
            this.warnMessage = ''
            this.warnVisible = true;
          }
          this.showTips = true;
        }, 1000);
      }
      if (this.network) {
        severTime().then(res => {
          handleShow(res.data.sever_time)
        }).catch(err => {
          handleShow(nowTime())
        })
      } else {
        handleShow(nowTime())
      }
    },
    // 从本场考试对应的 localStorage 恢复切屏次数和累计时长
    initSwitchInfo() {
      if (!this.switchStorageKey) return
      const stored = localStorage.getItem(this.switchStorageKey)
      if (!stored) return
      try {
        const info = JSON.parse(stored)
        this.switchRecords = Array.isArray(info.records) ? info.records : []
        this.switchTotalSeconds = Number(info.totalSeconds || 0)
        this.leaveNum = Number(info.cheatCount || 0)
      } catch (err) {
        localStorage.removeItem(this.switchStorageKey)
      }
    },
    // 保存单次切屏时长，并更新累计切屏时长和作弊次数
    saveSwitchInfo(duration, isCheatSwitch, startTime) {
      const switchDuration = Math.max(0, Number(duration) || 0)
      this.switchTotalSeconds += switchDuration
      if (isCheatSwitch) {
        this.leaveNum++
      }
      this.switchRecords.push({
        duration: switchDuration,
        date_start: startTime || this.leaveTime || nowTime(),
        date_end: nowTime(),
        is_cheat: isCheatSwitch ? 1 : 2
      })
      if (this.switchStorageKey) {
        localStorage.setItem(this.switchStorageKey, JSON.stringify({
          cheatCount: this.leaveNum,
          totalSeconds: this.switchTotalSeconds,
          records: this.switchRecords
        }))
      }
    },
    // 清理本场考试的切屏记录
    clearSwitchInfo() {
      if (this.switchStorageKey) {
        localStorage.removeItem(this.switchStorageKey)
      }
    },
    // 判断是否达到切屏次数、累计时长或单次时长的强制交卷阈值
    getSwitchLimitType(duration) {
      const countExceeded = this.switchCheat === 1 && this.numTotal !== 0 && this.leaveNum > this.numTotal
      const totalExceeded = this.switchCheat === 1 && this.longSwitchDetection === 1 && this.switchTotalSeconds > this.longSwitchTotalMinute * 60
      const singleExceeded = this.switchCheat === 1 && this.longSwitchDetection === 1 && duration > this.longSwitchSingleMinute * 60
      if (totalExceeded) return 'duration'
      if (singleExceeded) return 'duration'
      if (countExceeded) return 'count'
      return ''
    },
    // 根据触发原因展示强制交卷提示，实际交卷仍由原确认流程处理
    showSwitchSubmitWarning(type) {
      this.submit_type = 5
      this.warnEnd = true
      this.tipParmas.tipsVisible = false
      this.warnMessage = type === 'duration' ? '切屏时间过长，已触发防作弊，强制交卷！' : ''
      if (this.network) {
        this.warnVisible = true
      } else {
        this.warnVisible = false
        this.tipParmas = {
          tipsContent: `<div>${type === 'duration' ? '切屏时间过长，已触发防作弊，强制交卷！' : '请注意，当前已触发防作弊自动交卷'}但网络环境较差无法自动交卷，请调整网络！否则会按漏考统计，调整网络后弹窗会自动关闭</div>`,
          tipsVisible: true,
          showClose: false,
          disabled: false
        }
      }
    },
    countUnansweredQuestions() {
      return this.exams.filter(item => {
        if (item.type == 2 || item.type == 18) {
          return Array.isArray(item.value) && item.value.length < 2;
        }
        return !item.value || (Array.isArray(item.value) && item.value.length === 0);
      }).length;
    },
    async submit() {
      this.loading = true
      try {
      severTime().then(res => {
        const queryData = {
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          exam_id: this.examDetailed.id
        }
        getExamDetail(queryData).then(res3 => {
          this.loading = false
          if (res3.code == 200) {
            const time2 = res3.data.submit_minute * 60
            if (res3.data.reset_answer && res3.data.reset_answer.is_reset) {
              if (time2 > Number(dateMinutes2(res.data.sever_time, this.date_start)) + Number(res3.data.reset_answer.exam_time)) {
                this.$refs.tipParmas.btnChange(false)
                return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
              }
            } else {
              if (time2 > dateMinutes2(res.data.sever_time, this.date_start)) {
                this.$refs.tipParmas.btnChange(false)
                return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
              }
            }
            const examNum = this.countUnansweredQuestions();
            this.examType = 'start';
            this.tipParmas = {
              tipsContent: examNum > 0 ? `<div>当前还有<span style="color:#DD594A">${examNum}题未作答</span>，是否交卷，交卷将结束此次考试？</div>` : `<div>交卷将结束此次考试，是否交卷？</div>`,
              tipsVisible: true,
              confirmText: '交卷',
              cancelText: '取消',
              showClose: true,
              disabled: false
            }
          } else {
            if (res3.message == "您已被管理员强制交卷，有问题请联系管理员") {
              this.submit_type = 6
              this.forceConfirm('', res.data.sever_time);
            }
            if (res3.message === "本场考试已取消" || res3.message === '您已被移出本场考试') {
              localStorage.removeItem('examId')
              localStorage.removeItem('testInfo')
              localStorage.removeItem('unsentAnswers')
              localStorage.removeItem('examTimeStart')
              localStorage.removeItem('testPaper')
              localStorage.removeItem('nowTopic')
              localStorage.removeItem('stayTime')
              clearInterval(this.intervalId)
              this.$router.go(-2);
            }
          }
        })
      })
      } catch (error) {
        this.loading = false
      }
    },
    handleFullscreenChange() {
      this.isFullscreen = isFullscreenActive();
      if (!this.isFullscreen && this.showFull) {
        this.$messageBox.alert('考试期间不允许退出全屏', '警告', {
          confirmButtonText: '确定',
          callback: action => {
            fullScreen();
          }
        });
      }
    },
    pageHidden() {
      if (document.visibilityState === 'hidden') {
        this.pageHide();
      } else {
        this.pageShow();
      }
    },
    topicsSeq() {
      return [1, 11, 12, 15, 16, 17, 22, 2, 18, 19, 8];
    },
    hasData(value) {
      if (typeof value === 'string') {
        return value.length > 0;
      } else if (Array.isArray(value)) {
        return value.length > 0;
      } else {
        return false;
      }
    },
    topicChange(data) {
      if (this.$route.query.type) {
        let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
        nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
        this.progress.current = nextIndex;
        this.getTopicInfo();
      } else {
        if (this.topic.id == data.id) {
          return
        }
        if (this.examDetailed.answer_mode == 1) {
          if ((this.topic.type == 2 || this.topic.type == 18) && this.topic.value.length < 2) {
            return this.$message.error('至少选择2个答案')
          }
          let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
          nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
          this.progress.current = nextIndex;
        } else if (this.examDetailed.answer_mode == 2) {
          if (this.examDetailed.answer_rule == 1) {
            if (data.nextCheck) {
              return this.$message.error('当前为逐题-不可回看模式，不能回看上一个题型哟!')
            }
            if (!this.hasData(this.topic.value)) {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
            if (this.topic.value.length < 2 && (this.topic.type == 2 || this.topic.type == 18)) {
              return this.$message.error('至少选择2个答案')
            }
            const id = this.exams.map(item => item.id).indexOf(this.topic.id) + 1
            const id2 = this.exams.map(item => item.id).indexOf(data.id)
            if (id != id2) {
              return this.$message.error('请按照题号顺序进行作答')
            }
            this.exams[this.topicIndex].nextCheck = true
            let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
            nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
            this.progress.current = nextIndex;
            this.$nextTick(() => {
              this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            })
            return
          } else {
            if (this.hasData(this.topic.value)) {
              if (data.nextCheck) {
                let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
                nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                this.progress.current = nextIndex;
                return
              }
              if (this.topic.value.length < 2 && (this.topic.type == 2 || this.topic.type == 18)) {
                return this.$message.error('至少选择2个答案')
              }
              if (data.id == this.nowTopic.id) {
                let nextIndex = this.exams.map(item => item.id).indexOf(this.nowTopic.id) + 1
                nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                this.progress.current = nextIndex;
                return
              } else {
                const id = this.exams.map(item => item.id).indexOf(this.topic.id) + 1
                const id2 = this.exams.map(item => item.id).indexOf(data.id)
                if (id != id2) {
                  return this.$message.error('请按照题号顺序进行作答')
                }
              }
              this.exams[this.topicIndex].nextCheck = true;
              let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
              nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
              this.progress.current = nextIndex;
              this.$nextTick(() => {
                this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
              })
              return
            } else {
              if (this.hasData(data.value)) {
                let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
                nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                this.progress.current = nextIndex;
                return
              } else {
                return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
              }
            }
          }
        } else if (this.examDetailed.answer_mode == 3) {
          if ((data.nextCheck && this.examDetailed.answer_rule == 1) || (data.nextCheck && this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (this.topic.type == 8 || this.topic.type == 15))) {
            return
          }
          if ((data.type == 8 || data.type == 15) && this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 1 && (this.topic.type == 8 || this.topic.type == 15)) { // 题组题不能回看按顺序作答
            if (this.hasData(this.topic.value)) {
              const id = this.exams.map(item => item.id).indexOf(this.topic.id) + 1
              const id2 = this.exams.map(item => item.id).indexOf(data.id)
              if (id != id2) {
                return this.$message.error('请按照题号顺序进行作答')
              }
            } else {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
          }
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 1) {
            if (data.nextCheck) {
              let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
              nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
              this.progress.current = nextIndex;
              return
            }
            if ((data.type == 8 || data.type == 15) && (this.topic.type == 8 || this.topic.type == 15)) {
              if (this.hasData(this.topic.value)) {
                if (this.topic.nextCheck) {
                  const id = this.exams.map(item => item.id).indexOf(this.nowTopic.id)
                  const id2 = this.exams.map(item => item.id).indexOf(data.id)
                  if (id != id2) {
                    return this.$message.error('请按照题号顺序进行作答')
                  }
                } else {
                  const id = this.exams.map(item => item.id).indexOf(this.topic.id) + 1
                  const id2 = this.exams.map(item => item.id).indexOf(data.id)
                  if (id != id2) {
                    return this.$message.error('请按照题号顺序进行作答')
                  }
                }
              } else {
                return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
              }
            }
            if ((data.type == 8 || data.type == 15) && this.topic.nextCheck) {
              const id = this.exams.map(item => item.id).indexOf(this.nowTopic.id)
              const id2 = this.exams.map(item => item.id).indexOf(data.id)
              if (id != id2) {
                return this.$message.error('请按照题号顺序进行作答')
              }
            }
          }
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
            if (data.nextCheck) {
              let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
              nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
              this.progress.current = nextIndex;
              return
            }
            if ((data.type == 8 || data.type == 15) && (this.topic.type == 8 || this.topic.type == 15)) {
              if (!this.hasData(data.value)) {
                if (!this.hasData(this.topic.value)) {
                  return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
                }
              }
            }
            if ((data.type == 8 || data.type == 15) && this.topic.nextCheck) {
              const id = this.exams.map(item => item.id).indexOf(this.nowTopic.id)
              const id2 = this.exams.map(item => item.id).indexOf(data.id)
              if (!this.hasData(this.exams.find(item => item.id == this.nowTopic.id).value)) {
                if (id != id2) {
                  return this.$message.error(`请先对题目(${this.exams.map(item => item.id).indexOf(this.nowTopic.id) + 1}题)进行作答`)
                }
              }
            }
          }
          if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (this.topic.type == 8 || this.topic.type == 15)) {
            if (!this.hasData(this.topic.value)) {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
          }
          if (data.type == this.nowType || data.nextCheck) {
            if (((this.examDetailed.subtopic_answer_rule == 1) || (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2)) && (this.topic.type == 8 || this.topic.type == 15)) {
              this.exams[this.topicIndex].nextCheck = true
              this.nowTopic = JSON.parse(JSON.stringify(this.findLastObjectWithNonEmptyValue([...this.exams])))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            }
            if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (this.topic.type == 8 || this.topic.type == 15)) {
              this.exams[this.topicIndex].nextCheck = true
            }
            let nextIndex = this.exams.map(item => item.id).indexOf(data.id) + 1
            nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
            this.progress.current = nextIndex;
            if (this.examDetailed.answer_rule == 2 && this.topic.type != 8 && this.topic.type != 15 && !data.nextCheck) {
              this.nowTopic = JSON.parse(JSON.stringify(this.topic))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            }
            if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && (this.topic.type == 8 || this.topic.type == 15) && !data.nextCheck) {
              this.nowTopic = JSON.parse(JSON.stringify(this.topic))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            }
            return
          }
          const typeNum = this.exams.filter(item => item.type == this.nowType).length
          const doNum = this.exams.filter(item => {
            if (Array.isArray(item.value)) {
              // return item.value.length > 0 && item.type == this.nowType;
              if (item.type == 2 || item.type == 18) {
                return item.value.length > 1 && item.type == this.nowType;
              } else {
                return item.value.length > 0 && item.type == this.nowType;
              }
            } else {
              return item.value !== '' && item.type == this.nowType;
            }
          }).length;
          if (typeNum != doNum) {
            const noNum = []
            this.exams.map(item => {
              if (item.type == this.nowType) {
                if (item.type == 2 || item.type == 18) {
                  if (item.value.length < 2) {
                    noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                  }
                } else {
                  if ((Array.isArray(item.value) && item.value.length == 0) || item.value == '') {
                    noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                  }
                }
              }
            })
            this.tipParmas3 = {
              tipsVisible: true,
              title: '系统提示',
              tipsContentTitle: '请先完成对当前题型的作答',
              tipsContentText: noNum.length >= 20 ? '请完成当前题型未做题目' : `当前题型未作答题目：${noNum.join(',')}号题`,
              confirmText: '确定',
              type: 1
            }
            return
          } else {
            const typeQuetions = this.exams.filter(item => item.type == this.nowType)
            if ((this.nextType == 8 || this.nextType == 15) && (data.type == 8 || data.type == 15)) {
              if (this.examDetailed.subtopic_answer_rule == 1) {
                if (this.exams.filter(item => item.type == this.nextType)[0].id != data.id) {
                  return this.$message.error('当前模式题组题型需按顺序作答，所以题组题型请从该题型第一道开始答题')
                }
              }
            }
            if (data.type == this.nextType) {
              this.checkId = data.id;
              this.tipParmas3 = {
                tipsVisible: true,
                title: '操作确认',
                tipsContentTitle: '是否切换题型作答？',
                tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                cancelText: '取消',
                confirmText: '确定',
                type: 2
              }
              return
            } else {
              this.tipParmas3 = {
                tipsVisible: true,
                title: '操作确认',
                tipsContentTitle: '不能跨题型答题！',
                tipsContentText: `请按照题型顺序作答`,
                confirmText: '确定',
                type: 1
              }
              return
            }
          }
        }
      }
    },
    generateKeys(array) {
      if (array && array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          const new_key = String.fromCharCode(65 + i);
          array[i].new_key = new_key;
        }
        return array;
      }
    },
    sortOptions(arr, keyOrder) {
      if (arr.length > 0) {
        const sortArr = arr.sort((a, b) => keyOrder.indexOf(a.key) - keyOrder.indexOf(b.key));
        return this.generateKeys(sortArr)
      } else {
        return []
      }
    },
    getExamList() {
      if (localStorage.getItem('testPaper')) {
        var examlist = []
        if (this.$route.query.type || this.examDetailed.reset_answer.is_reset) {
          if (this.anwserList.length > 0) {
            this.anwserList.map(obj => {
              JSON.parse(localStorage.getItem('testPaper')).map(item => {
                if (obj.question_id == item.id) {
                  if (item.type === 22) {
                    item.option = JSON.stringify([{
                      key: 'A',
                      title: '正确'
                    }, {
                      key: 'B',
                      title: '错误'
                    }])
                    item.answer = JSON.parse(item.option).filter(obj => obj.title == item.answer)[0].key
                  }
                  item.answers =  obj.answer
                  item.is_right = obj.is_right;
                  item.remarks = obj.remarks;
                  item.new_key = obj.new_key;
                  item.option = this.$route.query.type ? this.generateKeys(JSON.parse(item.option)) :  obj.newAnswerOptions ? this.sortOptions(JSON.parse(item.option), obj.newAnswerOptions.replace(/,/g, '').replace(/，/g, '').split('')) : this.generateKeys(JSON.parse(item.option));
                  if (item.type === 2 || item.type === 8 || item.type === 18 || item.type === 19) {
                    item.value = obj.answer ? obj.answer.replace(/,/g, '').replace(/，/g, '').split('') : []
                  } else {
                    item.value = obj.answer
                  }
                  if (!this.$route.query.type) {
                    if (this.examDetailed.answer_mode == 2) {
                      if (this.hasData(item.value) && item.id != this.examDetailed.reset_answer.last_answer) {
                        item.nextCheck = true;
                      }
                    } else if (this.examDetailed.answer_mode == 3) {
                      if (this.examDetailed.reset_answer.last_answer) {
                        const type = JSON.parse(localStorage.getItem('testPaper')).find(item => item.id == this.examDetailed.reset_answer.last_answer).type
                        if (item.type == 8 || item.type == 15) {
                          if (this.examDetailed.subtopic_prohibit_rollback == 2) {
                            if (this.hasData(item.value) && item.id != this.examDetailed.reset_answer.last_answer) {
                              item.nextCheck = true;
                            }
                          } else {
                            if (this.hasData(item.value) && item.type != type) {
                              item.nextCheck = true;
                            }
                          }
                        } else {
                          if (this.hasData(item.value) && item.type != type) {
                            item.nextCheck = true;
                          }
                        }
                      }
                    }
                  }

                  examlist.push(item)
                }
              })
            })
          } else {
            JSON.parse(localStorage.getItem('testPaper')).map(item => {
              item.is_right = 0;
              item.option = this.generateKeys(JSON.parse(item.option));
              if (item.type === 2 || item.type === 8 || item.type === 18 || item.type === 19) {
                item.value =  []
              } else {
                item.value = ''
              }
              examlist.push(item)
            })
          }
        } else {
          examlist = JSON.parse(localStorage.getItem('testPaper')).map(item => {
            item.option = typeof item.option !== 'string' ? item.option : this.generateKeys(JSON.parse(item.option))
            if (item.type === 2 || item.type === 8 || item.type === 18 || item.type === 19) {
              item.value = []
            } else {
              item.value = ''
            }
            return item
          })
        }
        // console.log(examlist, 'examlist')
        const examGroup = examlist.reduce((r, c) => {
          if (!r[c.type]) {
            r[c.type] = []
          }
          r[c.type].push(c)
          return r
        }, {})
        const topicsSeq = this.topicsSeq()
        const groupedSorted = topicsSeq.map(order => examGroup[order]).filter(v => v && v.length !== 0)
        const shuffledArray =  groupedSorted.map(item => {
          const totalScore = item.reduce((sum, item) => sum + item.score, 0);
          item.map(obj => {
            obj.scoreTotal = totalScore
            obj.numTotal = item.length
          })
          if (item[0].type == 8 || item[0].type == 15 || item[0].type == 16) {
            const groupedData = item.reduce((acc, obj) => {
              if (obj.public_number) {
                let group = acc.find(group => group.name === obj.public_number);
                if (!group) {
                  group = { name: obj.public_number, list: [] };
                  acc.push(group);
                }
                group.list.push(obj);
              } else {
                acc.push({ name: obj.id, list: [obj] });
              }
              return acc;
            }, []);
            groupedData.forEach(group => {
              const groupLength = group.list.length;
              const groupScore = group.list.reduce((sum, item) => sum + item.score, 0);
              group.list.forEach(item => {
                item.groupLength = groupLength;
                item.groupScore = groupScore
              });
            });
            const mergedList = groupedData.reduce((acc, item) => acc.concat(item.list), []);
            return mergedList
          } else {
            return item
          }
        })
        const sortedExams = shuffledArray.reduce((r, c) => {
          if (typeof c !== 'undefined') {
            r = r.concat(...c)
          }
          return r
        }, [])
        const saved = localStorage.getItem('unsentAnswers')
        if (saved) this.onceSubmitArr = JSON.parse(saved)
        this.exams = sortedExams;
        localStorage.setItem('testInfo', JSON.stringify(this.exams))
        this.oldExamList = JSON.parse(JSON.stringify(this.exams))
        this.examNum = -1
        this.progress.total = sortedExams.length
        this.loading = false;
        console.log(this.exams, 'this.exams------')
        if (!this.$route.query.type) {
          const hasSessionState = localStorage.getItem('testInfo') && localStorage.getItem('examTimeStart') && localStorage.getItem('examAnswerId') && this.examDetailed.id == localStorage.getItem('examId') && this.userId == localStorage.getItem('userId')
          if (!hasSessionState) {
            this.$message.error('考试初始化失败，请返回考试详情页重新进入');
            this.$router.go(-2)
            return
          }
          this.initExamSession()
        } else {
          this.getTopicInfo();
        }
      } else {
        this.$message.error('获取试卷失败');
          this.$router.go(-2)
      }
    },
    // 修改时间触发作弊
    async isModifyTime(behavior_type){
      const localTime = new Date().getTime()
      const severTimeRes = await severTime()
      const serverTime = new Date(severTimeRes.data.sever_time).getTime()
      const timeDiff = Math.abs(localTime - serverTime) / 1000  // 转换为秒
      const exam_change_time = localStorage.getItem('examChangeTime') || 5
      if (timeDiff > Number(exam_change_time)) {
        this.saveCheatNum('',2,9,{date_time:nowTime(localTime),behavior_type})
      }
    },
    getTime() {
      severTime().then(res => {
        this.date_start = res.data.sever_time
        if (this.examDetailed.reset_answer.is_reset) {
          const time = this.getExamTime(this.date_start, this.examDetailed.ent_time, this.examDetailed.answer_time)// 总共考试时间-秒
          const time2 = this.getExamTime(this.examDetailed.reset_answer.date_start, this.examDetailed.ent_time, this.examDetailed.answer_time)
          const time3 = time > time2 - this.examDetailed.reset_answer.exam_time ? time2 - this.examDetailed.reset_answer.exam_time : time
          this.endTime = dateToString2(this.date_start, time3)
        } else {
          this.endTime = dateToString2(this.date_start, this.getExamTime(this.date_start, this.examDetailed.ent_time, this.examDetailed.answer_time))
          // this.endTime = dateToString2(new Date(this.date_start), this.getExamTime(new Date(this.date_start), this.examDetailed.ent_time, this.examDetailed.answer_time))
        }
        this.gwtExamContDwo =  this.endTime;
        this.timeShow = true;
        this.startTimer();
        if (this.examDetailed.answer_time === 0 && !this.$route.query.type) {
          if (this.examDetailed.reset_answer.is_reset) {
            const time = Number(this.examDetailed.reset_answer.exam_time)
            this.hour = parseInt(time / 3600)
            this.minute = parseInt((time - this.hour * 3600) / 60)
            this.second = time % 60 // 转换秒
          }
          this.start();
        }
      })
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    shuffle2DArray(arr) {
      return arr.map(subArray => this.shuffleArray(subArray));
    },
    getExamTime(startTime, endTime, examTime) {
      const lefttime = getExamTimestamp(endTime) - getExamTimestamp(startTime)
      const time1 = lefttime / 1000
      return examTime * 60 > time1 ? time1 : examTime * 60
    },
    async getTopicInfo() {
      this.topicVideo = [];
      const res = await getQuestionAdditional({
        question_id: this.exams[this.topicIndex].id,
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      });
      if (res.code === 200) {
        this.topicVideo = res.data.video;
        this.topicStatistics = res.data.stat;
        this.outlines = res.data.outlines
      }
    },
    findNextEmptyValueIndex(arr, currentId, direction) {
      const currentIndex = arr.findIndex(item => item.id === currentId);
      if (currentIndex === -1) {
        return false;
      }
      if (direction === 'next') {
        for (let i = currentIndex + 1; i < arr.length; i++) {
          if (arr[i].value === '' || (Array.isArray(arr[i].value) && arr[i].value.length === 0)) {
            return arr[i].id;
          }
        }
      } else if (direction === 'prev') {
        for (let i = currentIndex - 1; i >= 0; i--) {
          const value = arr[i].value;
          if (value === '' || (Array.isArray(value) && value.length === 0)) {
            return arr[i].id;
          }
        }
      }
      return false;
    },
    onUpdate({ id, index, value }) {
      const topic = this.exams[this.topicIndex];
      if (topic.id !== id) {
        return;
      }
      if (!this.$route.query.type) {
        if (this.examDetailed.answer_mode == 3) {
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 1 && topic.nextCheck) {
            let nextIndex = this.topicIndex + 1
            nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
            this.progress.current = nextIndex + 1;
            return
          }
          if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
            const checkNum = this.exams.filter(item => item.type == topic.type && item.nextCheck).length
            const typeNum = this.exams.filter(item => item.type == topic.type).length
            if (checkNum == typeNum && this.nowTopic.type == topic.type) {
              let nextIndex = this.topicIndex + 1
              nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
              this.progress.current = nextIndex + 1;
              return
            }
          }
          if ((topic.type != 8 && topic.type != 15 && !topic.nextCheck) || (this.examDetailed.subtopic_answer_rule == 1 && (topic == 8 || topic.type == 15))) { // 其他类型
            let nextIndex = this.topicIndex + 1
            nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
            const nextType = this.exams[nextIndex].type
            if (topic.type != nextType) {
              const typeNum = this.exams.filter(item => item.type == topic.type).length
              const doNum = this.exams.filter(item => {
                if (Array.isArray(item.value)) {
                  if (topic.type == 2 || topic.type == 18) {
                    return item.value.length > 1 && item.type == topic.type;
                  } else {
                    return item.value.length > 0 && item.type == topic.type;
                  }
                } else {
                  return item.value !== '' && item.type == topic.type;
                }
              }).length;
              if (typeNum != doNum) {
                const noNum = []
                this.exams.map(item => {
                  if (item.type == topic.type) {
                    if (topic.type == 2 || topic.type == 18) {
                      if (item.value.length < 2) {
                        noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                      }
                    } else {
                      if ((Array.isArray(item.value) && item.value.length == 0) || item.value == '') {
                        noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                      }
                    }
                  }
                })
                this.tipParmas3 = {
                  tipsVisible: true,
                  title: '系统提示',
                  tipsContentTitle: '请先完成对当前题型的作答',
                  tipsContentText: noNum.length >= 20 ? '请完成当前题型未做题目' : `当前题型未作答题目：${noNum.join(',')}号题`,
                  confirmText: '确定',
                  type: 1
                }
                return
              } else {
                const typeQuetions = this.exams.filter(item => item.type == topic.type)
                this.tipParmas3 = {
                  tipsVisible: true,
                  title: '操作确认',
                  tipsContentTitle: '是否切换题型作答？',
                  tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                  confirmText: '确定',
                  cancelText: '取消',
                  type: 2
                }
                const e = this.exams.filter(item => item.type == this.nextType)[0].id
                this.checkId = e;
                return
              }
            }
          } else {
            let nextIndex = this.topicIndex + 1
            nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
            const nextType = this.exams[nextIndex].type
            const typeArr = this.exams.filter(item => item.type == topic.type)
            const typeNum = typeArr.length
            const doNum = this.exams.filter(item => {
              if (Array.isArray(item.value)) {
                if (topic.type == 2 || topic.type == 18) {
                  return item.value.length > 1 && item.type == topic.type;
                } else {
                  return item.value.length > 0 && item.type == topic.type;
                }
              } else {
                return item.value !== '' && item.type == topic.type;
              }
            }).length;
            const endId = typeArr[typeArr.length - 1].id

            if (!topic.nextCheck) {
              if (topic.type != nextType) {
                if (typeNum != doNum) {
                  const noNum = []
                  this.exams.map(item => {
                    if (item.type == topic.type) {
                      if (topic.type == 2 || topic.type == 18) {
                        if (item.value.length < 2) {
                          noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                        }
                      } else {
                        if ((Array.isArray(item.value) && item.value.length == 0) || item.value == '') {
                          noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                        }
                      }
                    }
                  })
                  this.tipParmas3 = {
                    tipsVisible: true,
                    title: '系统提示',
                    tipsContentTitle: '请先完成对当前题型的作答',
                    tipsContentText: noNum.length >= 20 ? '请完成当前题型未做题目' : `当前题型未作答题目：${noNum.join(',')}号题`,
                    confirmText: '确定',
                    type: 1
                  }
                  return
                } else {
                  const typeQuetions = this.exams.filter(item => item.type == topic.type)
                  this.tipParmas3 = {
                    tipsVisible: true,
                    title: '操作确认',
                    tipsContentTitle: '是否切换题型作答？',
                    tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                    confirmText: '确定',
                    cancelText: '取消',
                    type: 2
                  }
                  const e = this.exams.filter(item => item.type == this.nextType)[0].id
                  this.checkId = e;
                  return
                }
              }
              if (this.examDetailed.subtopic_answer_rule == 2) {
                if (endId == topic.id) {
                  if (typeNum == doNum) {
                    const typeQuetions = this.exams.filter(item => item.type == topic.type)
                    this.tipParmas3 = {
                      tipsVisible: true,
                      title: '操作确认',
                      tipsContentTitle: '是否切换题型作答？',
                      tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                      confirmText: '确定',
                      cancelText: '取消',
                      type: 2
                    }
                    const e = this.exams.filter(item => item.type == this.nextType)[0].id
                    this.checkId = e;
                    return
                  }
                }
              } else {
                if (typeNum == doNum) {
                  const typeQuetions = this.exams.filter(item => item.type == topic.type)
                  this.tipParmas3 = {
                    tipsVisible: true,
                    title: '操作确认',
                    tipsContentTitle: '是否切换题型作答？',
                    tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                    confirmText: '确定',
                    cancelText: '取消',
                    type: 2
                  }
                  const e = this.exams.filter(item => item.type == this.nextType)[0].id
                  this.checkId = e;
                  return
                }
              }
            }
          }
        }
        if (this.examDetailed.answer_mode == 2 || ((this.examDetailed.subtopic_answer_rule == 1 || (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2)) && (topic.type == 8 || topic.type == 15))) {
          this.exams[this.topicIndex].nextCheck = true
          this.nowTopic = JSON.parse(JSON.stringify(this.findLastObjectWithNonEmptyValue([...this.exams])))
          localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (topic.type == 8 || topic.type == 15)) {
          const typeQuetions = this.exams.filter(item => item.type == topic.type)
          const nextIndex = this.findNextEmptyValueIndex(typeQuetions, topic.id, 'next')
          if (nextIndex) {
            let nextIndex2 = this.exams.map(item => item.id).indexOf(nextIndex)
            nextIndex2 = Math.min(Math.max(0, nextIndex2), this.exams.length - 1)
            this.progress.current = nextIndex2 + 1;
            return
          } else {
            const typeNum = this.exams.filter(item => item.type == topic.type).length
            const doNum = this.exams.filter(item => {
              if (Array.isArray(item.value)) {
                if (item.type == 18 || item.type == 2) {
                  return item.value.length > 1 && item.type == topic.type;
                } else {
                  return item.value.length > 0 && item.type == topic.type;
                }
              } else {
                return item.value !== '' && item.type == topic.type;
              }
            }).length;
            if (typeNum != doNum) {
              const noNum = []
              this.exams.map(item => {
                if (item.type == topic.type) {
                  if (item.type == 2 || item.type == 18) {
                    if (item.value.length < 2) {
                      noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                    }
                  } else {
                    if ((Array.isArray(item.value) && item.value.length == 0) || item.value == '') {
                      noNum.push(this.exams.map(val => val.id).indexOf(item.id) + 1)
                    }
                  }
                }
              })
              this.tipParmas3 = {
                tipsVisible: true,
                title: '系统提示',
                tipsContentTitle: '请先完成对当前题型的作答',
                tipsContentText: noNum.length >= 20 ? '请完成当前题型未做题目' : `当前题型未作答题目：${noNum.join(',')}号题`,
                confirmText: '确定',
                type: 1
              }
              return
            } else {
              const typeQuetions = this.exams.filter(item => item.type == topic.type)
              this.tipParmas3 = {
                tipsVisible: true,
                title: '操作确认',
                tipsContentTitle: '是否切换题型作答？',
                tipsContentText: this.examDetailed.answer_rule == 1 ? `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)将禁止查看` : `切换后当前题型(${this.exams.map(val => val.id).indexOf(typeQuetions[0].id) + 1}~${this.exams.map(val => val.id).indexOf(typeQuetions[typeQuetions.length - 1].id) + 1}题号)仅能查看，禁止再次作答`,
                confirmText: '确定',
                cancelText: '取消',
                type: 2
              }
              const e = this.exams.filter(item => item.type == this.nextType)[0].id
              this.checkId = e;
              return
            }
          }
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
          if (!this.hasData(topic.value)) {
            if (!this.hasData(this.exams[this.topicIndex + 1].value)) {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
          } else {
            if (topic.nextCheck) {
              if (!this.hasData(this.exams[this.topicIndex + 1].value)) {
                if (!this.hasData(this.exams.find(item => item.id == this.nowTopic.id).value)) {
                  if (this.exams[this.topicIndex + 1].id != this.nowTopic.id) {
                    return this.$message.error(`请先对题目(${this.exams.map(item => item.id).indexOf(this.nowTopic.id) + 1}题)进行作答`)
                  } else {
                    let nextIndex = this.topicIndex + 1
                    nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
                    this.progress.current = nextIndex + 1;
                    this.$nextTick(() => {
                      this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                      localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                    })
                    return
                  }
                } else {
                  if (this.exams[this.topicIndex + 1].id != this.nowTopic.id) {
                    const index = this.exams.map(item => item.id).indexOf(this.nowTopic.id)
                    this.exams[index].nextCheck = true;
                    this.$nextTick(() => {
                      let nextIndex = this.topicIndex + 1
                      nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
                      this.progress.current = nextIndex + 1;
                      this.$nextTick(() => {
                        this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                        localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                      })
                    })
                    return
                  }
                }
              }
            } else {
              if (!this.hasData(this.exams[this.topicIndex + 1].value)) {
                this.exams[this.topicIndex].nextCheck = true
                let nextIndex = this.topicIndex + 1
                nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
                this.progress.current = nextIndex + 1;
                this.$nextTick(() => {
                  this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                  localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                })
                return
              }
            }
          }
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 2) {
          let nextIndex = this.topicIndex + 1
          nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
          this.progress.current = nextIndex + 1;
          this.$nextTick(() => {
            if (!this.topic.nextCheck) {
              this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            }
          })
          return
        }
      }

      this.processNext()
      if (this.$route.query.type) {
        this.getTopicInfo();
      }
    },
    processNext() {
      let nextIndex = this.topicIndex + 1
      nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
      this.progress.current = nextIndex + 1;
    },
    onPrevUpData({ id, index, value }) {
      const topic = this.exams[this.topicIndex]
      if (topic.id !== id) {
        return;
      }
      if (!this.$route.query.type) {
        if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 1 && (topic.type == 8 || topic.type == 15)) {
          return this.$message.error('当前为题组题-按顺序模式，不能回看上一个题型哟!')
        }

        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1) {
          let nextIndex = this.topicIndex
          nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
          const nextType = this.exams[nextIndex - 1].type
          if (topic.type != nextType) {
            return this.$message.error('当前为逐题型-不可回看模式，不能回看上一个题型哟!')
          }
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (topic.type == 8 || topic.type == 15)) {
          const typeQuetions = this.exams.filter(item => item.type == topic.type)
          const nextIndex = this.findNextEmptyValueIndex(typeQuetions, topic.id, 'prev')
          if (nextIndex) {
            if (!this.hasData(topic.value)) {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
            this.exams[this.topicIndex].nextCheck = true
            this.nowTopic = JSON.parse(JSON.stringify(this.findLastObjectWithNonEmptyValue([...this.exams])))
            localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            let nextIndex2 = this.exams.map(item => item.id).indexOf(nextIndex)
            nextIndex2 = Math.min(Math.max(0, nextIndex2), this.exams.length - 1)
            this.progress.current = nextIndex2 + 1;
            return
          } else {
            return this.$message.error('当前模式已做过的题目无法查看，前方已无未答题目')
          }
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2 && (topic.type == 8 || topic.type == 15)) {
          if (!this.hasData(topic.value)) {
            if (!this.hasData(this.exams[this.topicIndex - 1].value)) {
              return this.$message.error(`请先对题目(${this.progress.current}题)进行作答`)
            }
          } else {
            if (topic.nextCheck) {
              if (!this.hasData(this.exams[this.topicIndex - 1].value)) {
                if (!this.hasData(this.exams.find(item => item.id == this.nowTopic.id).value)) {
                  if (this.exams[this.topicIndex - 1].id != this.nowTopic.id) {
                    return this.$message.error(`请先对题目(${this.exams.map(item => item.id).indexOf(this.nowTopic.id) + 1}题)进行作答`)
                  } else {
                    let nextIndex = this.topicIndex + 1
                    nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                    const index = (nextIndex - 1) <= 0 ? 1 : (nextIndex - 1)
                    this.progress.current = index
                    this.$nextTick(() => {
                      this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                      localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                    })
                    return
                  }
                } else {
                  if (this.exams[this.topicIndex - 1].id != this.nowTopic.id) {
                    const index = this.exams.map(item => item.id).indexOf(this.nowTopic.id)
                    this.exams[index].nextCheck = true;
                    this.$nextTick(() => {
                      let nextIndex = this.topicIndex + 1
                      nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                      const index = (nextIndex - 1) <= 0 ? 1 : (nextIndex - 1)
                      this.progress.current = index
                      this.$nextTick(() => {
                        this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                        localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                      })
                    })
                    return
                  }
                }
              }
            } else {
              if (!this.hasData(this.exams[this.topicIndex - 1].value)) {
                this.exams[this.topicIndex].nextCheck = true
                let nextIndex = this.topicIndex + 1
                nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
                const index = (nextIndex - 1) <= 0 ? 1 : (nextIndex - 1)
                this.progress.current = index
                this.$nextTick(() => {
                  this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
                  localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
                })
                return
              }
            }
          }
        }
        if (this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 2) {
          let nextIndex = this.topicIndex + 1
          nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
          const index = (nextIndex - 1) <= 0 ? 1 : (nextIndex - 1)
          this.progress.current = index
          this.$nextTick(() => {
            if (!this.topic.nextCheck) {
              this.nowTopic = JSON.parse(JSON.stringify(this.exams[this.topicIndex]))
              localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
            }
          })
          return
        }
      }

      this.processPrev()
      if (this.$route.query.type) {
        this.getTopicInfo();
      }
    },
    processPrev() {
      let nextIndex = this.topicIndex + 1
      nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length)
      const index = (nextIndex - 1) <= 0 ? 1 : (nextIndex - 1)
      this.progress.current = index
    },
    onCheckTips() {
      this.$set(this.exams[this.topicIndex], 'remarks', !this.exams[this.topicIndex].remarks)
    },
    statisticsChange() {
      this.statisticsVisible = false;
      if (!this.$route.query.type) {
          this.$router.go(-2);
      }
    },
    countEnd() {
      this.examType = 'start';
      this.submit_type = 4
      if (!this.network) {
        this.tipParmas = {
          tipsContent: `<div>请注意，当前倒计时已结束，但网络环境较差无法自动交卷，请调整网络！否则会按漏考统计，调整网络后弹窗会自动关闭</div>`,
          tipsVisible: true,
          showClose: false,
          disabled: false
        }
      } else {
        this.$refs.countDown.endCount();
        this.getNoWorkEnd(2)
      }
    },
    getNoWorkEnd(type) {
      getExamDetail({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.examDetailed.id
      }).then(res => {
        if (res.data.answer_time != this.answer_time) {
          this.answer_time = res.data.answer_time
          const time = this.getExamTime(this.date_start, res.data.ent_time, res.data.answer_time)
          this.endTime = dateToString2(this.date_start, time)
        } else {
          this.tipsConfirm(type);
        }
      })
    },
    tipsClose() {
      if (this.examType === 'start' || this.examType === 'showRank') {
        this.tipParmas.tipsVisible = false;
      }
      if (this.examType === 'end') {
        this.tipParmas.tipsVisible = false;
        this.statisticsVisible = true;
      }
      if (this.examType === 'addTime') {
        this.tipParmas2.tipsVisible = false;
      }
      if (this.examType === 'remove') {
        localStorage.removeItem('examId')
        localStorage.removeItem('testInfo')
        localStorage.removeItem('unsentAnswers')
        this.clearSwitchInfo()
        // closeWebsocket();
        this.tipParmas2.tipsVisible = false;
        this.warnVisible = false;
        this.$router.go(-2);
      }
    },
    tipsClose2() {
      this.tipParmas3.tipsVisible = false;
    },
    tipsConfirm2(type) {
      if (type == 1) {
        this.tipParmas3.tipsVisible = false;
      } else if (type == 2) {
        this.exams.map(item => {
          if (item.type == this.nowType) {
            item.nextCheck = true;
          }
        })
        // let nextId = this.exams.filter(item=>item.type==this.nextType)[0].id
        // let nextId = this.exams.filter(item=>item.type==this.nextType)[0].id
        let nextIndex = this.exams.map(item => item.id).indexOf(this.checkId)
        nextIndex = Math.min(Math.max(0, nextIndex), this.exams.length - 1)
        this.progress.current = nextIndex + 1;
        this.tipParmas3.tipsVisible = false;
        this.$nextTick(() => {
          this.nowType = this.topic.type;
          this.nextType = this.getNextQuesType(this.nowType)
          // let nowArr=this.exams.filter(item=>item.type==this.nowType)
          this.nowTopic = JSON.parse(JSON.stringify(this.topic))
          localStorage.setItem('nowTopic', JSON.stringify(this.nowTopic))
          if ((this.nowType == 8 || this.nowType == 15) && this.firstTypeShow) {
            let content = ''
            // 首次进入题组题提示
            if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 1) {
              content = '<p>1.本场考试题组题子题必须按照题号顺序作答</p><p>2.只有做完当前子题才能切换下一个子题作答</p><p>3.已做完的子题禁止回退查看</p>'
            }
            if (this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
              content = '<p>本场考试题组题题型内已做完的子题禁止回退查看</p>'
            }
            if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 1) {
              content = '<p>1.本场考试题组题子题必须按照题号顺序作答</p><p>2.只有做完当前子题才能切换下一个子题作答</p><p>3.已做完的子题仅支持查看，禁止再次答题</p>'
            }
            if (this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) {
              content = '<p>本场考试题组题题型内已做完的子题仅支持查看，禁止再次答题</p>'
            }
            if (content) {
              this.tipTypeParmas2 = {
                tipsVisible: true,
                tipsContent: content
              }
            }
          }
        })
      }
    },
    async tipsConfirm(type) {
      if (this.examType === 'end') {
        this.tipParmas.tipsVisible = false;
        this.statisticsVisible = true;
      } else if (this.examType === 'showRank') {
        this.tipParmas.tipsVisible = false;
      } else if (this.examType === 'addTime') {
        this.tipParmas2.tipsVisible = false;
      } else if (this.examType === 'remove') {
        localStorage.removeItem('examId')
        localStorage.removeItem('testInfo')
        localStorage.removeItem('unsentAnswers')
        this.clearSwitchInfo()
        closeWebsocket();
        this.tipParmas2.tipsVisible = false;
        this.warnVisible = false;
        this.$router.go(-2);
      } else {
        this.$refs.tipParmas?.btnChange(true)
        this.tipParmas.disabled = true
        severTime().then(res => {
          const queryData = {
            token: localStorage.getItem('token'),
            secret: localStorage.getItem('secret'),
            hospital_id: localStorage.getItem('hospital_id'),
            exam_id: this.examDetailed.id
          }
          getExamDetail(queryData).then(res3 => {
            // const time2 = res3.data.submit_minute * 60
            // if (res3.data.reset_answer && res3.data.reset_answer.is_reset) { // 重置过逻辑
            //   if (time2 > Number(dateMinutes2(res.data.sever_time, this.date_start)) + Number(res3.data.reset_answer.exam_time)) {
            //     this.$refs.tipParmas.btnChange(false)
            //     return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
            //   }
            // } else {
            //   if (time2 > dateMinutes2(res.data.sever_time, this.date_start)) {
            //     this.$refs.tipParmas.btnChange(false)
            //     return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
            //   }
            // }
            if (res3.code == 200) {
              this.forceConfirm(type, res.data.sever_time)
            } else {
              this.warnVisible = false;
              this.tipParmas.tipsVisible = false;
              this.tipParmas2.tipsVisible = false;
              this.$refs.tipParmas.btnChange(false)
              if (res3.message == "您已被管理员强制交卷，有问题请联系管理员") {
                this.submit_type = 6
                this.forceConfirm('', res.data.sever_time);
              }
              if (res3.message === "本场考试已取消" || res.message === '您已被移出本场考试') {
                localStorage.removeItem('examId')
                localStorage.removeItem('testInfo')
                localStorage.removeItem('unsentAnswers')
                localStorage.removeItem('examTimeStart')
                localStorage.removeItem('testPaper')
                localStorage.removeItem('nowTopic')
                localStorage.removeItem('stayTime')
                clearInterval(this.intervalId)
                this.$router.go(-2);
              }
            }
          }).catch(err2 => {
            console.log(err2, '2222222')
            this.tipParmas.disabled = false
            this.warnVisible = false;
            this.tipParmas.tipsVisible = false;
            this.tipParmas2.tipsVisible = false;
            this.$refs.tipParmas.btnChange(false)
          })
        })
      }
    },
    warnCancel() {
      if (this.warnEnd) {
        this.tipsConfirm();
      }
      this.warnVisible = false;
    },
    goStatistics(e) {
      if (this.examDetailed.status != 2) {
        if (e == 1) {
          this.examType = 'showRank'
          this.tipParmas = {
            tipsContent: `<div>当前考试还未结束，待考试结束后统一公布排名</div>`,
            tipsVisible: true,
            confirmText: '确认',
            showClose: true
          }
          return
        }
      }
      if (e == 1 && this.examDetailed.result != 1) {
        this.examType = 'showRank'
        this.tipParmas = {
          tipsContent: `<div>本场考试不统计排名，有问题请联系管理员</div>`,
          tipsVisible: true,
          confirmText: '确认',
          showClose: true
        }
        return
      }
      if (this.examDetailed.result == 3) {
        this.examType = 'showRank'
        this.tipParmas = {
          tipsContent: `<div>本场考试不在系统中公布成绩，有问题请联系管理员</div>`,
          tipsVisible: true,
          confirmText: '确认',
          showClose: true
        }
        return
      }
      this.statisticsType = e;
      this.statisticsVisible = true;
    },
    start() {
      this.flag = setInterval(() => {
        this.second = this.second + 1;
        if (this.second >= 60) {
          this.second = 0;
          this.minute = this.minute + 1;
        }

        if (this.minute >= 60) {
          this.minute = 0;
          this.hour = this.hour + 1;
        }
        this.timer =
          this.complZero(this.hour) +
          ":" +
          this.complZero(this.minute) +
          ":" +
          this.complZero(this.second);
      }, 1000);
    },
    complZero(n) {
      return n < 10 ? "0" + n : "" + n;
    },
    startHeartbeat() {
      this.heartbeatTimer = setInterval(async () => {
        try {
          await severTime()
          if (!this.network) {
            this.network = true
            if (this.offlineStartTime) {
              const duration = Math.round((Date.now() - this.offlineStartTime) / 1000)
              const examDisconnectInternet = localStorage.getItem('examDisconnectInternet') || 5
              if (duration > Number(examDisconnectInternet)) {
                this.saveCheatNum(duration, 2, 8)
              }
              this.offlineStartTime = null
            }
          }
        } catch {
          if (this.network) {
            this.network = false
            this.offlineStartTime = Date.now()
          }
        }
      }, 5000)
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
      }
    },
    async saveCheatNum(time, type,cheatType=1,info={}) {
      if(!localStorage.getItem('examTimeStart')){
        this.$messageBox.close()
        this.$router.go(-2)
        return
      }
      if (this.network) {
        const cheat_data_json = JSON.stringify([{
            exam_id: this.examDetailed.id,
            date_start: localStorage.getItem('examTimeStart'),
            time: time || 1,
            type: cheatType,
            is_cheat: type,
            ...info
          }])
        const res = await saveCheatBatch({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          cheat_data:cheat_data_json
        })
      } else {
        this.noWorkChearArr.push({
          time: time,
          type: type,
          cheatType: cheatType,
          info: info
        })
      }
    },
    async flushCheatQueue() {
      if (this.noWorkChearArr.length === 0) return
      const batch = this.noWorkChearArr.map(item => ({
        exam_id: this.examDetailed.id,
        date_start: localStorage.getItem('examTimeStart'),
        time: item.time || 1,
        type: item.cheatType || 1,
        is_cheat: item.type,
        ...(item.info || {})
      }))
      this.noWorkChearArr = []
      await saveCheatBatch({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        cheat_data: JSON.stringify(batch)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.examining-app {
    // padding: 0 8px 8px 8px;
    padding: 16px 24px;
    background-color: #F7F8FA;
    height: 100%;
}

.examing-main {
    justify-content: space-around;
    // padding:0px 24px 24px 24px;
}

.el-container {
    height: 100%;
}

.el-main {
    flex: 9;
    background-color: #fff;
    margin-right: 16px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
    overflow-y: hidden;
    padding: 0;
}

.el-aside {
    border-radius: 4px;
    flex: 3;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.count {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: #fff;
    margin-bottom: 16px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
    padding: 16px 24px;
    .time{
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #303030;
      margin: 0 0 10px 0;
    }
    .coutDwo{
      width: 16px;
      margin-right: 6px;
    }
    .score{
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-size: 26px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: bold;
      color: #303030;
      background: #F7F8FA;
      border-radius: 4px 4px 4px 4px;
    }
}

.exam-item {
    background-color: #fff;
    flex: 7;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
    padding: 0 24px;
    height: calc(100% - 162px);
    // overflow-y: auto;
}

.count p {
    margin: 10px 0;

}

.count img {
    vertical-align: sub;
    margin-right: 5px;
}

.dwon {
    width: 100%;
    height: 42px;
    text-align: center;
    line-height: 42px;
    background: rgba(95,202,113,0.08);
    border-radius: 4px;
    color: #5FCA71;
    font-size: 26px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    .timer{
      font-size: 26px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: bold;
      color: #5FCA71;
    }
}

.progress-bar {
    width: 100%;
    overflow: hidden;
    margin-top: 16px;
}

.progress-bar span {
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #303030;
}

.el-progress__text {
    font-size: 12px !important;
    color: #5FCA71;
}

.exam-item-title {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    border-bottom: solid 1px #eee;
    font-size: 12px;
    .tab{
      cursor: pointer;
    }
}

.exam-item-title>div {
    display: flex;
    align-items: center;
}

.exam-item-title span {
    width: 12px;
    height: 12px;
    margin-right: 5px;
}
.right span{
  background-color: #5FCA71;
}
.wrong span{
  background-color: #DD594A;
}
.done span {
    background-color: #F5BC41;
}

.not-done span {
    background-color: #EEEEEE;
}

.active span {
    border: 1px solid #F5BC41;
}
.tag{
  width: 12px;
  margin-right: 4px;
}
.exam-item-content {
    padding:0px 0px 24px 0px;
    overflow-y: auto;
    // height: 100%;
    // height: calc(100% - 110px);
}

.item-content-tips {
    display: flex;
    justify-content: flex-start;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #303030;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 16px;
    line-height: 1;
}

.item-content-tips span {
    display: block;
    width: 3px;
    height: 16px;
    background-color: #DD594A;
    margin-right: 5px;
}

.single-content {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}

.content-item {
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    margin: 0px 12px 12px 0;
    position: relative;
    cursor: pointer;
}

.content-item img {
    position: absolute;
    top: 0;
    right: 0;
}

.blue {
    background-color: #F5BC41;
    color: #FFFFFF;

}

.yellow {
    border: 1px solid #F5BC41;
    color: #F5BC41;
    background-color: #fff;
}

.white {
    background: #EEEEEE;
    border: solid 1px #EEEEEE;
    color: #303030;
}
.wrong2{
  background-color: #FFF4F2;
  color: #EB5C55;
}
.right2{
  background-color: #F2FFFA;
  color: #5FCA71;
}
.tag_img{
  width: 12px;
}
.paper_btn{
  margin-top: 10px;
}
::v-deep{
  .el-alert--info.is-light{
    background-color: #FFF3F0;
    color: #EB5C55;
    position: absolute;
    top: 60px;
    z-index: 100;
    left: 0;
  }
}
.dis_color{
  background: #F8F2E4;
  color: #E9D3A5;
}
.nowTopic{
  font-size:10px;
  color:#F5BC41;
  background-color: #fff;
  border:1px solid #f5bc41;
}
</style>
